import axios from "axios";
import * as ActionType from "./reward.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

export const getRewardApi =
  (start, limit, startDate, endDate) => async (dispatch) => {
    try {
      if (!start || !limit || !startDate || !endDate) {
        setToast("error", "Missing required parameters");
        return;
      }
      const response = await apiInstanceFetch.get(
        `admin/reward/allAdvertisment?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
      );
      dispatch({
        type: ActionType.GET_ADVERTISMENT,
        payload: response.AdReward,
      });
    } catch (error) {
      console.error("Get Rewards Error:", error);
      setToast("error", "Failed to fetch rewards. Please try again.");
    }
  };
export const createReward = (formData) => async (dispatch) => {
  try {
    if (!formData.adName || !formData.coins || !formData.isActive) {
      setToast("error", "Missing required parameters");
      return;
    }
    const response = await axios.post(
      "admin/reward/createAdvertisment",
      formData,
    );
    if (response.status) {
      dispatch({
        type: ActionType.ADD_ADVERTISMENT,
        payload: response.data.ad,
      });
      setToast("success", "Reward created successfully!");
    }
  } catch (error) {
    console.error("Create Reward Error:", error);
    setToast("error", "Failed to create reward. Please try again.");
  }
};

export const editReward = (data, rewardId) => (dispatch) => {
  if (!rewardId) {
    setToast("error", "Missing required parameters");
    return;
  }
  axios
    .patch(`admin/reward/Advertisment?adId=${rewardId}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.EDIT_ADVERTISMENT,
          payload: { data: res.data.adReward, rewardId: rewardId },
        });
        setToast("success", "Reward Edit SuccessFully");
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteReward = (rewardId) => (dispatch) => {
  axios
    .delete(`admin/reward/Advertisment?adId=${rewardId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_ADVERTISMENT,
          payload: rewardId,
        });
        setToast("success", "Reward Deleted Successfully");
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const getReferral = () => async (dispatch) => {
  try {
    const response = await apiInstanceFetch.get("admin/reward/referral");
    dispatch({ type: ActionType.GET_REFERRAL, payload: response.refReward });
    console.log("Referral", response.refReward);
  } catch (error) {
    console.error("Get Referral Error:", error);
    setToast("error", "Failed to fetch referral. Please try again.");
  }
};

export const createReferral = (formData) => async (dispatch) => {
  try {
    const response = await axios.post("admin/reward/referral", formData);
    dispatch({ type: ActionType.ADD_REFERRAL, payload: response.data.ref });
    setToast("success", "Referral created successfully!");
  } catch (error) {
    console.error("Create Referral Error:", error);
    setToast("error", "Failed to create referral. Please try again.");
  }
};

export const editReferral = (data, referralId) => (dispatch) => {
  try {
    if (!referralId) {
      setToast("error", "Missing required parameters");
      return;
    }
    axios
      .patch(`admin/reward/referral?adId=${referralId}`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ActionType.EDIT_REFERRAL,
            payload: res.data.updatedref,
          });
          setToast("success", "Referral edited successfully!");
        }
      });
  } catch (error) {
    console.error("Edit Referral Error:", error);
    setToast("error", "Failed to edit referral. Please try again.");
  }
};

export const deleteReferral = (referralId) => (dispatch) => {
  try {
    if (!referralId) {
      setToast("error", "Missing required parameters");
      return;
    }
    axios.delete(`admin/reward/referral?adId=${referralId}`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_REFERRAL,
          payload: res.data.delRef,
        });
        setToast("success", "Referral deleted successfully!");
      }
    });
  } catch (error) {
    console.error("Delete Referral Error:", error);
    setToast("error", "Failed to delete referral. Please try again.");
  }
};

export const getEngagement = () => async (dispatch) => {
  try {
    const response = await apiInstanceFetch.get(
      "admin/reward/engagementReward",
    );
    dispatch({ type: ActionType.GET_ENGAGEMENT, payload: response.actReward });
  } catch (error) {
    console.error("Get Engagement Error:", error);
    setToast("error", "Failed to get engagement. Please try again.");
  }
};

export const createEngagement = (formData) => async (dispatch) => {
  try {
    if (
      !formData.adName ||
      !formData.coins ||
      !formData.isActive ||
      !formData.type
    ) {
      setToast("error", "Missing required parameters");
      return;
    }
    const response = await axios.post(
      "admin/reward/engagementReward",
      formData,
    );
    if (response.data.status) {
      dispatch({
        type: ActionType.ADD_ENGAGEMENT,
        payload: response.data.addedEngagement,
      });
      setToast("success", "Engagement created successfully!");
    }
  } catch (error) {
    console.error("Create Engagement Error:", error);
    setToast("error", "Failed to create engagement. Please try again.");
  }
};

export const editEngagement = (data, engagementId) => (dispatch) => {
  try {
    if (!engagementId) {
      setToast("error", "Missing required parameters");
      return;
    }
    axios
      .patch(`admin/reward/engagementReward?adId=${engagementId}`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ActionType.EDIT_ENGAGEMENT,
            payload: { data: res.data.updatedAct, engagementId: engagementId },
          });
          setToast("success", "Engagement edited successfully!");
        }
      });
  } catch (error) {
    console.error("Edit Engagement Error:", error);
    setToast("error", "Failed to edit engagement. Please try again.");
  }
};

export const deleteEngagement = (engagementId) => (dispatch) => {
  try {
    if (!engagementId) {
      setToast("error", "Missing required parameters");
      return;
    }
    axios
      .delete(`admin/reward/engagementReward?adId=${engagementId}`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ActionType.DELETE_ENGAGEMENT,
            payload: res.data.delAct,
          });
          setToast("success", "Engagement deleted successfully!");
        }
      });
  } catch (error) {
    console.error("Delete Engagement Error:", error);
    setToast("error", "Failed to delete engagement. Please try again.");
  }
};
